<template>
  <div class="Ftim-box">
    <div class="Ftim-bt">
      <span>至德-</span>经济
      <i></i>
    </div>

    <div class="Current-box">
      <div class="Currbj-left"></div>

      <div class="Currbj-cent">

        <div class="" v-if="open==1">
          <div class="Currbj-title">{{continfo.title}}</div>
          <div class="Currbj-info" v-html="continfo.content"></div>
          <div class="Currbj-but" @click="setin(1)">同意并完善</div>
        </div>

        <div class="" v-if="open==2">
          <div class="Agree-title">完善信息</div>
          <div class="Agree-Inp">
            <em>*</em>
            <label>姓名</label>
            <el-input
              v-model="info.user_name"
              class="Agree-info"
              placeholder="请输入姓名">
            </el-input>
          </div>
          <div class="Agree-Inp">
            <em>*</em>
            <label>身份证号</label>
           <el-input
              v-model="info.user_id_number"
              class="Agree-info"
              placeholder="请输入身份证号">
            </el-input>
          </div>
          <div class="Agree-Inp">
            <em>*</em>
            <label>住址</label>
            <el-input
              v-model="info.user_address"
              class="Agree-info"
              placeholder="请输入住址">
            </el-input>
          </div>
          <div class="Agree-Inp">
            <em>*</em>
            <label>企业全称</label>
            <el-input
              v-model="info.company_name"
              class="Agree-info"
              placeholder="请输入营业执照企业名称">
            </el-input>
          </div>
          <div class="Agree-Inp">
            <em>*</em>
            <label>信用代码</label>
            <el-input
              v-model="info.credit_code"
              class="Agree-info"
              placeholder="请输入营业执照上的信用代码">
            </el-input>
          </div>
          <div class="Agree-Inp">
            <em>*</em>
            <label>注册地址</label>
            <el-input
              v-model="info.company_address"
              class="Agree-info"
              placeholder="请输入营业执照上的注册地址">
            </el-input>
          </div>
          <div class="Agree-Inp">
            <em>*</em>
            <label>注册资本</label>
            <el-input
              v-model="info.company_capital"
              class="Agree-info"
              placeholder="请输入营业执照上的注册地址">
            </el-input>
          </div>
          <div class="Agree-Inp Agree-dx">
            <em>*</em>
            <label>是否实缴</label>
            <div class="Agree-rode">
              <el-radio v-model="info.is_paid" label="1">是</el-radio>
              <el-radio v-model="info.is_paid" label="0">否</el-radio>
            </div>
          </div>
          <div class="Agree-tarea">
            <em>*</em>
            <label>公司经营范围</label>
            <el-input 
              v-model="info.scope_of_business"
              class="Agree-info"
              type="textarea"
              :rows="3"
              placeholder="请输入经营范围…">
            </el-input>
          </div>
          <div class="Agree-tarea">
            <em></em>
            <label>公司主要产品名称</label>
            <el-input 
              v-model="info.company_product_name"
              class="Agree-info"
              type="textarea"
              :rows="3"
              placeholder="请输入限制200字"
              maxlength='200'>
            </el-input>
          </div>
          <div class="Agree-tarea">
            <em></em>
            <label>产品获得“三品一标”情况</label>
            <el-input 
              v-model="info.company_sanping_yibiao"
              class="Agree-info"
              type="textarea"
              :rows="3"
              placeholder="请输入限制200字"
              maxlength='200'>
            </el-input>
          </div>
          <div class="Agree-tarea">
            <em></em>
            <label>产品获得荣誉</label>
            <el-input
              v-model="info.company_product_honor"
              class="Agree-info"
              type="textarea"
              :rows="3"
              placeholder="请输入限制200字"
              maxlength='200'>
            </el-input>
          </div>
          <div class="Agree-tarea">
            <em></em>
            <label>公司获得荣誉</label>
            <el-input 
              v-model="info.company_honor"
              class="Agree-info"
              type="textarea"
              :rows="3"
              placeholder="请输入限制200字"
              maxlength='200'>
            </el-input>
          </div>
          <div class="Agree-tarea">
            <em></em>
            <label>其他</label>
            <el-input 
              v-model="info.company_other_info"
              class="Agree-info"
              type="textarea"
              :rows="3"
              placeholder="请输入限制200字"
              maxlength='200'>
            </el-input>
          </div>

          <div class="Agree-next" @click="setin(2)">下一步</div>
        </div>

        <div class="" v-if="open==3">
          <div class="Agree-title">企业信息</div>
          <div class="reinfo-uppic">
            <div class="reinfo-uptop">
              <i>*</i>
              <span>logo</span>
              <b>公司标识，png、jpg格式</b>
            </div>
            
            <div class="picture-box">
              <div class="picture-up" v-if="!info.logo">
                <el-upload
                  action=""
                  list-type="picture-card"
                  :before-upload="handlogo">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="picture-ever" v-if="info.logo">
                <div class="picture-list">
                  <img :src="info.logo">
                  <span @click="dellogo()"></span>
                </div>
              </div>
              
            </div>
          </div>
          <div class="reinfo-uppic">
            <div class="reinfo-uptop">
              <i></i>
              <span>缩略图</span>
              <b>最多上传9张图片</b>
            </div>
            
            <div class="picture-box">
              <div class="picture-up" v-if="ruleForm.length<9">
                <el-upload
                  action=""
                  list-type="picture-card"
                  :before-upload="handleBeforeUpload">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="picture-ever">
                <div class="picture-list" v-for="(item,index) in ruleForm" :key="index">
                  <img :src="item.url">
                  <span @click="delpic(index)"></span>
                </div>
              </div>
              
            </div>
          </div>
          <div class="Agree-tatwo">
            <em>*</em>
            <label>企业介绍</label>
            <el-input 
              v-model="info.company_intro"
              class="Agree-infotwo"
              type="textarea"
              :rows="7"
              placeholder="请输入介绍…">
            </el-input>
          </div>

          <div class="Agree-but">
            <div class="Agree-step" @click="setin(3)">上一步</div>
            <div class="Agree-settle" @click="submit()">提交入驻</div>
          </div>
          
        </div>
        
      </div>

      <div class="Currbj-right"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      token: localStorage.pctoken,  //获取token
      open: 1,
      continfo:'',
      info:{
        user_name:'',
        user_id_number:'',
        user_address:'',
        credit_code:'',
        company_name:'',
        company_address:'',
        company_capital:'',
        is_paid: '1',
        scope_of_business:'',
        company_product_name:'',
        company_sanping_yibiao:'',
        company_product_honor:'',
        company_honor:'',
        company_other_info:'',
        logo:'',
        company_album:[],
        company_intro:'',
      },
      ruleForm: [],
    };
  },
  created(){
    this.getData()
  },
  mounted() {
  },
  methods: {
    //获取内容
    getData(){
      this.$layer.loading();
      this.$http.get('other/content/3').then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.continfo = res.data.data;
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //跳转
    setin(num){
      if(num == 1){
        this.open = 2
      }else if(num == 2){
        if(!this.info.user_name){
          this.$layer.msg('请填写姓名');
          return
        }
        if(!this.info.user_id_number){
          this.$layer.msg('请填写身份证号');
          return
        }
        if(!this.info.user_address){
          this.$layer.msg('请填写住址');
          return
        }
        if(!this.info.company_name){
          this.$layer.msg('请填写企业全称');
          return
        }
        if(!this.info.credit_code){
          this.$layer.msg('请填写信用代码');
          return
        }
        
        if(!this.info.company_address){
          this.$layer.msg('请填写注册地址');
          return
        }
        if(!this.info.company_capital){
          this.$layer.msg('请填写注册资本');
          return
        }
        if(!this.info.scope_of_business){
          this.$layer.msg('请填写公司经营范围');
          return
        }
        // if(!this.info.company_product_name){
        //   this.$layer.msg('请填写公司主要产品名称');
        //   return
        // }
        // if(!this.info.company_sanping_yibiao){
        //   this.$layer.msg('请填写产品获得“三品一标”情况');
        //   return
        // }
        // if(!this.info.company_product_honor){
        //   this.$layer.msg('请填写产品获得荣誉');
        //   return
        // }
        // if(!this.info.company_honor){
        //   this.$layer.msg('请填写公司获得荣誉');
        //   return
        // }
        // if(!this.info.company_other_info){
        //   this.$layer.msg('请填写其他');
        //   return
        // }

        this.open = 3

        window.scrollTo({
          top: 300,
          behavior: "smooth" // 平滑滚动
        });
      }else if(num == 3){
        this.open = 2
      }
    },

    //上传logo
    handlogo(file) {
      const formData = new FormData();
      formData.append('img', file);
      this.uploadlogo(formData);
      return false;
    },
    uploadlogo(formData) {
      this.$layer.loading();
      this.$http.post('upload',formData,{
        headers: {
            'Authorization': 'Bearer ' + this.token}
      }).then((response)=>{
        if(response.data.code == 200){
          this.$layer.closeAll('loading');
          this.info.logo = response.data.data.path;
        }else{
          this.$layer.closeAll('loading');
        }
      });
    },

    //删除logo
    dellogo(){
      this.info.logo='';
    },

    //上传缩略图
    handleBeforeUpload(file) {
      const formData = new FormData();
      formData.append('img', file);
      this.uploadObject(formData);
      return false;
    },
    uploadObject(formData) {
      this.$layer.loading();
      this.$http.post('upload',formData,{
        headers: {
            'Authorization': 'Bearer ' + this.token}
      }).then((response)=>{
        if(response.data.code == 200){
          this.$layer.closeAll('loading');
          this.ruleForm.push({url:response.data.data.path});
        }else{
          this.$layer.closeAll('loading');
        }
      });
    },

    //删除缩略图
    delpic(index){
      this.ruleForm.splice(index,1)
    },

    //提交
    submit(){
      if(!this.info.logo){
        this.$layer.msg('请上传logo');
        return
      }

      // if(this.ruleForm.length == 0){
      //   this.$layer.msg('请上传缩略图');
      //   return
      // }

      if(!this.info.company_intro){
        this.$layer.msg('请填写企业介绍');
        return
      }

      this.$layer.loading();
      this.info.company_album = JSON.stringify(this.ruleForm)
      this.$http.post('complete/info',this.info,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.$layer.msg('已提交，审核中');
          setTimeout(() => {
            this.info = {
              user_name:'',
              user_id_number:'',
              user_address:'',
              credit_code:'',
              company_name:'',
              company_address:'',
              company_capital:'',
              is_paid: '1',
              scope_of_business:'',
              company_product_name:'',
              company_sanping_yibiao:'',
              company_product_honor:'',
              company_honor:'',
              company_other_info:'',
              logo:'',
              company_album:[],
              company_intro:'',
            }
            let weekArray = JSON.parse(localStorage.getItem('user'));
            weekArray.company_id = res.data.data.id;
            localStorage.setItem("user", JSON.stringify(weekArray));
            this.$router.push({name:"Index"})
          }, 1500);
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    }
  },
};
</script>
<style scoped>
  .Ftim-box{
    background: url(../../../public/images/dysjbjt.png) top no-repeat;
    margin-bottom: 20px;
  }
  .Ftim-bt{
    width: 1200px;
    margin: 72px auto 0;
    font-weight: bold;
    font-size: 48px;
    color: #333;
    line-height: 48px;
  }
  .Ftim-bt span{
    color: #D71E1C;
  }
  .Ftim-bt i{
    display: block;
    width: 48px;
    height: 4px;
    background: #D71E1C;
    margin-top: 30px;
  }
  .Current-box{
    width: 1200px;
    margin: 80px auto 0;
    display: flex;
  }
  .Currbj-left{
    width: 30px;
    height: 790px;
    background: url(../../../public/images/grleft.png) bottom no-repeat;
  }
  .Currbj-right{
    width: 30px;
    height: 790px;
    background: url(../../../public/images/grright.png) bottom no-repeat;
  }
  .Currbj-cent{
    flex: 1;
    background: #fff;
    border-radius: 20px 20px 0 0;
    padding: 74px 40px 0;
    position: relative;
  }
  .Currbj-title{
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    text-align: center;
  }
  .Currbj-info{
    margin-top: 30px;
    height: 76%;
    overflow: auto;
  }
  .Currbj-but{
    position: absolute;
    left: 50%;
    bottom: 30px;
    width: 200px;
    height: 36px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    transform: translate(-50%,0);
    cursor: pointer;
  }
  .Agree-Inp{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #d8d8d8;
    padding-top: 20px;
  }
  .Agree-Inp em{
    font-size: 16px;
    color: #D71E1C;
  }
  .Agree-Inp label{
    display: block;
    width: 230px;
    font-size: 16px;
    color: #333;
    margin-left: 6px;
  }
  ::v-deep .Agree-info .el-input__inner{
    font-size: 16px;
    margin-left: 40px;
    border: none;
  }
  .Agree-tarea{
    display: flex;
    border-bottom: 1px solid #d8d8d8;
    padding-top: 20px;
  }
  .Agree-tarea em{
    font-size: 16px;
    color: #D71E1C;
    padding-top: 6px;
  }
  .Agree-tarea label{
    display: block;
    width: 230px;
    font-size: 16px;
    color: #333;
    margin-left: 6px;
    padding-top: 6px;
  }
  ::v-deep .Agree-info .el-textarea__inner{
    width: 96%;
    font-size: 16px;
    margin-left: 40px;
    border: none;
    resize: none;
  }
  .Agree-rode{
    display: flex;
    margin-left: 7px;
  }
  .Agree-rode label{
    width: 60px;
  }
  ::v-deep .Agree-rode .el-radio__label{
    font-size: 16px;
    color: #333;
  }
  .Agree-dx{
    padding-bottom: 10px;
  }
  .Agree-next{
    width: 200px;
    height: 36px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    margin: 58px auto 0;
    cursor: pointer;
  }
  .reinfo-uppic{
    border-bottom: 1px dotted #D8D8D8;
    margin-top: 20px;
    padding-bottom: 16px;
  }
  .reinfo-uptop{
    display: flex;
    align-items: center;
  }
  .reinfo-uptop i{
    width: 6px;
    color: #E2195C;
  }
  .reinfo-uptop span{
    width: 110px;
    font-size: 16px;
    color: #333;
    margin-left: 2px;
  }
  .reinfo-uptop b{
    font-size: 16px;
    color: #D8D8D8;
    font-weight: 400;
  }
  .picture-box{
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-left: 120px;
  }
  .picture-up{
    margin-right: 20px;
  }
  .picture-ever{
    display: flex;
    align-items: center;
  }
  .picture-list{
    position: relative;
    margin-right: 20px;
  }
  .picture-list img{
    width: 72px;
    height: 72px;
    border-radius: 6px;
  }
  .picture-list span{
    display: block;
    position: absolute;
    top: -8px;
    right: -9px;
    width: 18px;
    height: 18px;
    background: url(../../../public/images/gb.png) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .Agree-but{
    width: 500px;
    margin: 58px auto 0;
    display: flex;
    align-items: center;
  }
  .Agree-step{
    width: 200px;
    height: 36px;
    background: #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #333;
    line-height: 36px;
    text-align: center;
    margin: 58px auto 0;
    cursor: pointer;
  }
  .Agree-settle{
    width: 200px;
    height: 36px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    margin: 58px auto 0;
    cursor: pointer;
  }
  .Agree-title{
    font-weight: bold;
    font-size: 32px;
    color: #333333;
  }
  .Agree-tatwo{
    display: flex;
    border-bottom: 1px solid #d8d8d8;
    padding-top: 20px;
  }
  .Agree-tatwo em{
    font-size: 16px;
    color: #D71E1C;
    padding-top: 6px;
  }
  .Agree-tatwo label{
    display: block;
    width: 90px;
    font-size: 16px;
    color: #333;
    margin-left: 6px;
    padding-top: 6px;
  }
  ::v-deep .Agree-infotwo .el-textarea__inner{
    width: 96%;
    font-size: 16px;
    margin-left: 12px;
    border: none;
    resize: none;
  }
</style>